import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { saveAs } from 'file-saver';
import * as d3 from 'd3';
import { ScatterComponent } from 'src/app/shared/graphs/scatter/scatter.component';

@Component({
  selector: 'app-logscenbeacon',
  templateUrl: './logscenbeacon.component.html',
  styleUrls: ['./logscenbeacon.component.css']
})
export class LogscenbeaconComponent extends BaseComponent implements OnChanges {
  @Input() scenarioId = 0
  @ViewChild('scatter1') scatter1: ScatterComponent;
  @ViewChild('scatter2') scatter2: ScatterComponent;
  @ViewChild('scatter3') scatter3: ScatterComponent;
  beacons: any = []
  overview: any = []
  records: any = []
  recordsforplot: any = []
  sortArray: any = []
  beacongroups: any = []
  sensordisplay: any = {}
  phoneinfo = ""
  displayarray: any = []
  sensors: any = []

  constructor(injector: Injector) { super(injector) }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.scenarioId > 0) {
      this.overview = await this.db.get("beaconlog", "GetOverviewByScenarioId", { scenarioid: this.scenarioId })
      this.beacons = await this.db.get("beacon", "GetBeacons")
      this.sensors = await this.db.get("sensor", "GetSensors")
      this.overview.forEach((s: any) => {
        s.date = new Date(s.startDay);
        s.selected = false
      })
    }
  }

  async selectPhoneInfo(phoneInfo: string) {
    this.phoneinfo = phoneInfo
    this.refreshSensorDisplay()

    this.records = await this.db.post("beaconlog", "GetLogByScenAndPhoneInfos", [phoneInfo], { scenarioid: this.scenarioId })
    this.records = this.records.filter((r: any) => r.rssi < 0);
    let start = this.records[0].millis
    this.records.forEach((r: any) => {
      r.secs = (r.millis - start) / 1000
      let beacon = this.beacons.find((b: any) => b.name == r.beaconName)
      if (beacon != null) {
        r.distance = Math.pow(10, -(r.rssi - beacon.rssI1meter) / 10 / beacon.envFactor)
      } else {
        r.distance = Math.pow(10, -(r.rssi + 56) / 10 / 2.8)
      }

    })

    const AVERAGE_DISTANCE_LENGTH = 5;
    for (let i = 0; i < this.records.length; i++) {
      const startIndex = Math.max(0, i - AVERAGE_DISTANCE_LENGTH + 1);
      const endIndex = i + 1;
      const distances = this.records.slice(startIndex, endIndex).map((obj: any) => obj.distance);
      const averageDistance = distances.reduce((acc: any, val: any) => acc + val, 0) / distances.length;
      this.records[i].averagedistance = averageDistance;
    }

    this.beacongroups = this.groupBy(this.records, "beaconName")
    this.beacongroups.forEach((g: any) => {
      g.name = g.key
      g.nrecords = g.values.length
      let beacon = this.beacons.find((b: any) => b.name == g.name)
      g.rssi1m = 0.0
      g.envFactor = 0.0
      if (beacon != null) {
        g.rssi1m = beacon.rssI1meter
        g.envFactor = beacon.envFactor
      }
      let distminmax = this.minmax(g.values, "distance")
      let rssiminmax = this.minmax(g.values, "rssi")
      g.rssi_min = rssiminmax.min
      g.rssi_max = rssiminmax.max
      g.dist_min = distminmax.min
      g.dist_max = distminmax.max
    })

    this.recordsforplot = this.records
    this.plotscatter()
  }
  async refreshSensorDisplay() {
    let obj = { scenarioid: this.scenarioId, phoneinfo: this.phoneinfo }
    this.sensordisplay = await this.db.get("beaconlog", "GetSensorLogByScenarioIdAndPhoneInfo", obj)
    if (this.sensordisplay == undefined) {
      alert("No sensor data available")
      return
    }
    this.sensordisplay.difference = this.getTimeDifference(this.sensordisplay.dateCreated)
    let value = JSON.parse(this.sensordisplay.sensorValues)
    this.displayarray = []
    for (let key in value) {
      let sensorName = key
      let sensorValue = value[key]
      let sensor = this.sensors.find((s: any) => s.name == sensorName)
      let sensorUnit = sensor != null ? sensor.units : ""
      let obj = { sensorName: sensorName, sensorValue: sensorValue, sensorUnit: sensorUnit}
      this.displayarray.push(obj)
    }
    let a = 5
  }
  selectBeacon(beaconName: string) {
    this.recordsforplot = this.records.filter((b: any) => b.beaconName == beaconName)
    this.plotscatter()
  }
  plotscatter() {
    this.scatter1.configure("#69b3a2", 0.5, "Time [s]", "far<---- RSSI [dB] ----> close")
    this.scatter1.plot(this.recordsforplot, "secs", "rssi")

    this.scatter2.configure("#abd8ed", 0.8, "Time [s]", "Distance [m]")
    this.scatter2.plot(this.recordsforplot, "secs", "distance")

    this.scatter3.configure("#abd8ed", 0.8, "Time [s]", "Distance Average [m]")
    this.scatter3.plot(this.recordsforplot, "secs", "averagedistance")
  }
  sortCol(fieldname: string) {
    this.sortGeneric(this.overview, fieldname, this.sortArray)
  }
  async deleteSelected() {
    this.loader.show()
    let phoneinfos: any = []
    this.overview.forEach((o: any) => {
      if (o.selected == true) {
        phoneinfos.push(o.phoneInfo)
      }
    })
    await this.db.post("beaconlog", "DeleteBeaconLogByScenarioAndPhoneinfos", phoneinfos, { scenarioid: this.scenarioId })
    this.overview = await this.db.get("beaconlog", "GetOverviewByScenarioId", { scenarioid: this.scenarioId })
    this.overview.forEach((s: any) => {
      s.date = new Date(s.startDay);
      s.selected = false
    })
    this.loader.hide()
  }
  async refresh() {
    this.loader.show()
    this.overview = await this.db.get("beaconlog", "GetOverviewByScenarioId", { scenarioid: this.scenarioId })
    this.overview.forEach((s: any) => {
      s.date = new Date(s.startDay);
      s.selected = false
    })
    this.loader.hide()
  }
  downloadFile(data: any) {
    data = this.records
    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "beaconlogs.csv");
  }

  getTimeDifference(timestamp: number) {
    // Create a Date object for the current time
    const now = new Date();
    let fiveHours = 5 * 60 * 60 * 1000;
    // Create a Date object from the timestamp
    const then = new Date(timestamp + fiveHours);

    // Calculate the difference in milliseconds
    const diff = now.getTime() - then.getTime();

    // Convert milliseconds to days, hours, and minutes
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
}
}
